// Blog posts data with SEO keywords mapping
export const blogPosts = [
  {
    slug: 'dentist-amman',
    slugAr: 'طبيب-أسنان-عمان',
    title: 'Best Dentist in Amman - Dr. Yousef AlSaket Dental Clinic',
    titleAr: 'أفضل طبيب أسنان في عمان - عيادة الدكتور يوسف الساكت',
    keyword: 'Dentist Amman',
    keywordAr: 'طبيب أسنان عمان',
    keywords: ['Dentist Amman', 'Best dentist in Amman', 'Dental care Amman', 'Professional dentist Amman'],
    keywordsAr: ['طبيب أسنان عمان', 'أفضل طبيب أسنان في عمان', 'رعاية الأسنان عمان', 'طبيب أسنان متخصص عمان'],
    description: 'Expert dental care in Amman with Dr. Yousef AlSaket. Professional dental services, modern technology, and compassionate care for all your dental needs.',
    descriptionAr: 'رعاية أسنان متخصصة في عمان مع الدكتور يوسف الساكت. خدمات طب الأسنان المهنية، تقنيات حديثة، ورعاية متعاطفة لجميع احتياجاتك الأسنان.'
  },
  {
    slug: 'dental-clinic-amman',
    slugAr: 'عيادة-أسنان-عمان',
    title: 'Professional Dental Clinic in Amman - AlSaket Dental Clinics',
    titleAr: 'عيادة أسنان مهنية في عمان - عيادات الساكت',
    keyword: 'Dental clinic Amman',
    keywordAr: 'عيادة أسنان عمان',
    keywords: ['Dental clinic Amman', 'Dental care Amman', 'Amman dental clinic', 'Dental services Amman'],
    keywordsAr: ['عيادة أسنان عمان', 'رعاية الأسنان عمان', 'عيادة أسنان عمان', 'خدمات طب الأسنان عمان'],
    description: 'Professional dental clinic in Amman offering comprehensive dental services with modern equipment and experienced dentists.',
    descriptionAr: 'عيادة أسنان مهنية في عمان تقدم خدمات طب الأسنان الشاملة مع معدات حديثة وأطباء أسنان ذوي خبرة.'
  },
  {
    slug: 'best-dentist-amman',
    slugAr: 'أفضل-طبيب-أسنان-عمان',
    title: 'Best Dentist in Amman - Expert Dental Care by Dr. Yousef AlSaket',
    titleAr: 'أفضل طبيب أسنان في عمان - رعاية أسنان متخصصة من الدكتور يوسف الساكت',
    keyword: 'Best dentist in Amman',
    keywordAr: 'أفضل طبيب أسنان في عمان',
    keywords: ['Best dentist in Amman', 'Top dentist Amman', 'Expert dentist Amman', 'Dentist Amman'],
    keywordsAr: ['أفضل طبيب أسنان في عمان', 'أفضل طبيب أسنان عمان', 'طبيب أسنان خبير عمان', 'طبيب أسنان عمان'],
    description: 'Find the best dentist in Amman with Dr. Yousef AlSaket. Award-winning dental care with international qualifications and modern techniques.',
    descriptionAr: 'ابحث عن أفضل طبيب أسنان في عمان مع الدكتور يوسف الساكت. رعاية أسنان حائزة على جوائز مع مؤهلات دولية وتقنيات حديثة.'
  },
  {
    slug: 'al-yasmin-dentist',
    slugAr: 'طبيب-أسنان-الياسمين',
    title: 'Al Yasmin Dentist - Dental Care in Al Yasmin, Amman',
    titleAr: 'طبيب أسنان في الياسمين - رعاية الأسنان في الياسمين، عمان',
    keyword: 'Al Yasmin dentist',
    keywordAr: 'طبيب أسنان في الياسمين',
    keywords: ['Al Yasmin dentist', 'Dentist Al Yasmin Amman', 'Al Yasmin dental clinic', 'Dentist near Al Yasmin'],
    keywordsAr: ['طبيب أسنان في الياسمين', 'طبيب أسنان الياسمين عمان', 'عيادة أسنان الياسمين', 'طبيب أسنان قرب الياسمين'],
    description: 'Top-rated dentist serving Al Yasmin area in Amman. Expert dental care with convenient location and modern facilities.',
    descriptionAr: 'طبيب أسنان معتمد يخدم منطقة الياسمين في عمان. رعاية أسنان متخصصة مع موقع مريح ومرافق حديثة.'
  },
  {
    slug: 'dental-implants-amman',
    slugAr: 'زراعة-الأسنان-عمان',
    title: 'Dental Implants in Amman - Swiss Straumann Implants by Dr. AlSaket',
    titleAr: 'زراعة الأسنان في عمان - زراعات Straumann السويسرية من الدكتور الساكت',
    keyword: 'Dental implants Amman',
    keywordAr: 'زراعة الأسنان عمان',
    keywords: ['Dental implants Amman', 'Dental implant surgery Amman', 'Implant dentist Amman', 'Straumann implants Amman'],
    keywordsAr: ['زراعة الأسنان عمان', 'جراحة زراعة الأسنان عمان', 'طبيب زراعة الأسنان عمان', 'زراعات Straumann عمان'],
    description: 'Premium dental implants in Amman using Swiss Straumann technology. Expert implant surgery with high success rates and long-lasting results.',
    descriptionAr: 'زراعات أسنان عالية الجودة في عمان باستخدام تقنية Straumann السويسرية. جراحة زراعة متخصصة مع معدلات نجاح عالية ونتائج دائمة.'
  },
  {
    slug: 'teeth-whitening-amman',
    slugAr: 'تبييض-الأسنان-عمان',
    title: 'Teeth Whitening in Amman - Professional Whitening Services',
    titleAr: 'تبييض الأسنان في عمان - خدمات تبييض احترافية',
    keyword: 'Teeth whitening Amman',
    keywordAr: 'تبييض الأسنان عمان',
    keywords: ['Teeth whitening Amman', 'Laser teeth whitening Amman', 'Professional teeth whitening Amman', 'Dental whitening Amman'],
    keywordsAr: ['تبييض الأسنان عمان', 'تبييض الأسنان بالليزر عمان', 'تبييض أسنان احترافي عمان', 'تبييض الأسنان عمان'],
    description: 'Professional teeth whitening services in Amman. Safe, effective whitening treatments using latest international materials for a brighter smile.',
    descriptionAr: 'خدمات تبييض أسنان احترافية في عمان. علاجات تبييض آمنة وفعالة باستخدام أحدث المواد الدولية لابتسامة أكثر إشراقاً.'
  },
  {
    slug: 'orthodontics-amman',
    slugAr: 'تقويم-الأسنان-عمان',
    title: 'Orthodontics in Amman - Expert Orthodontic Treatment',
    titleAr: 'تقويم الأسنان في عمان - علاج تقويم متخصص',
    keyword: 'Orthodontics Amman',
    keywordAr: 'تقويم الأسنان عمان',
    keywords: ['Orthodontics Amman', 'Braces Amman', 'Orthodontic treatment Amman', 'Invisible braces Amman'],
    keywordsAr: ['تقويم الأسنان عمان', 'تقويم الأسنان عمان', 'علاج تقويم الأسنان عمان', 'تقويم شفاف عمان'],
    description: 'Expert orthodontic treatment in Amman. Straighten your teeth and improve your bite with professional orthodontic care.',
    descriptionAr: 'علاج تقويم متخصص في عمان. قوّم أسنانك وحسّن إطباقك مع رعاية تقويم احترافية.'
  },
  {
    slug: 'clear-aligners-amman',
    slugAr: 'تقويم-شفاف-عمان',
    title: 'Clear Aligners in Amman - Invisible Orthodontic Treatment',
    titleAr: 'تقويم شفاف في عمان - علاج تقويم غير مرئي',
    keyword: 'Clear aligners Amman',
    keywordAr: 'تقويم شفاف عمان',
    keywords: ['Clear aligners Amman', 'Invisible braces Amman', 'Invisalign Amman', 'Clear braces Amman'],
    keywordsAr: ['تقويم شفاف عمان', 'تقويم غير مرئي عمان', 'إنفزالاين عمان', 'تقويم شفاف عمان'],
    description: 'Clear aligners in Amman for invisible orthodontic treatment. Straighten your teeth discreetly with modern clear aligner technology.',
    descriptionAr: 'تقويم شفاف في عمان لعلاج تقويم غير مرئي. قوّم أسنانك بشكل غير ملحوظ مع تقنية التقويم الشفاف الحديثة.'
  },
  {
    slug: 'root-canal-amman',
    slugAr: 'علاج-قناة-الجذر-عمان',
    title: 'Root Canal Treatment in Amman - Advanced Endodontic Care',
    titleAr: 'علاج قناة الجذر في عمان - رعاية لبية متقدمة',
    keyword: 'Root canal Amman',
    keywordAr: 'علاج قناة الجذر عمان',
    keywords: ['Root canal Amman', 'Root canal treatment Amman', 'Endodontic treatment Amman', 'Dental root canal Amman'],
    keywordsAr: ['علاج قناة الجذر عمان', 'علاج العصب عمان', 'علاج لبي عمان', 'علاج قناة الجذر عمان'],
    description: 'Advanced root canal treatment in Amman using rotary devices and latest disinfection technology. Save your natural teeth with expert endodontic care.',
    descriptionAr: 'علاج قناة الجذر المتقدم في عمان باستخدام أجهزة الدوران وأحدث تقنية التطهير. احفظ أسنانك الطبيعية مع رعاية لبية متخصصة.'
  },
  {
    slug: 'tooth-extraction-amman',
    slugAr: 'خلع-ضرس-العقل-عمان',
    title: 'Tooth Extraction in Amman - Wisdom Teeth Removal',
    titleAr: 'خلع ضرس العقل في عمان - إزالة أسنان الحكمة',
    keyword: 'Tooth extraction Amman',
    keywordAr: 'خلع ضرس العقل عمان',
    keywords: ['Tooth extraction Amman', 'Wisdom teeth removal Amman', 'Dental extraction Amman', 'Tooth removal Amman'],
    keywordsAr: ['خلع ضرس العقل عمان', 'إزالة أسنان الحكمة عمان', 'خلع الأسنان عمان', 'إزالة الأسنان عمان'],
    description: 'Safe tooth extraction and wisdom teeth removal in Amman. Expert oral surgery with minimal discomfort and quick recovery.',
    descriptionAr: 'خلع آمن للأسنان وإزالة أسنان الحكمة في عمان. جراحة فم متخصصة مع ألم محدود وشفاء سريع.'
  },
  {
    slug: 'cosmetic-dentist-amman',
    slugAr: 'طبيب-أسنان-تجميلي-عمان',
    title: 'Cosmetic Dentist in Amman - Smile Makeover Services',
    titleAr: 'طبيب أسنان تجميلي في عمان - خدمات تجميل الابتسامة',
    keyword: 'Cosmetic dentist Amman',
    keywordAr: 'طبيب أسنان تجميلي عمان',
    keywords: ['Cosmetic dentist Amman', 'Smile makeover Amman', 'Aesthetic dentist Amman', 'Dental cosmetics Amman'],
    keywordsAr: ['طبيب أسنان تجميلي عمان', 'تجميل الابتسامة عمان', 'طبيب أسنان تجميلي عمان', 'تجميل الأسنان عمان'],
    description: 'Expert cosmetic dentistry in Amman. Transform your smile with veneers, whitening, and smile makeover procedures.',
    descriptionAr: 'طب أسنان تجميلي متخصص في عمان. حوّل ابتسامتك مع القشور، التبييض، وإجراءات تجميل الابتسامة.'
  },
  {
    slug: 'pediatric-dentist-amman',
    slugAr: 'طبيب-أسنان-أطفال-عمان',
    title: 'Pediatric Dentist in Amman - Children\'s Dental Care',
    titleAr: 'طبيب أسنان أطفال في عمان - رعاية أسنان الأطفال',
    keyword: 'Pediatric dentist Amman',
    keywordAr: 'طبيب أسنان أطفال عمان',
    keywords: ['Pediatric dentist Amman', 'Children\'s dentist Amman', 'Kids dentist Amman', 'Child dental care Amman'],
    keywordsAr: ['طبيب أسنان أطفال عمان', 'طبيب أسنان للأطفال عمان', 'طبيب أسنان أطفال عمان', 'رعاية أسنان الأطفال عمان'],
    description: 'Gentle pediatric dental care in Amman. Specialized children\'s dentistry with child-friendly approach and comfortable environment.',
    descriptionAr: 'رعاية أسنان أطفال لطيفة في عمان. طب أسنان أطفال متخصص مع نهج مناسب للأطفال وبيئة مريحة.'
  },
  {
    slug: 'emergency-dentist-amman',
    slugAr: 'طوارئ-أسنان-عمان',
    title: 'Emergency Dentist in Amman - 24/7 Dental Emergency Care',
    titleAr: 'طوارئ أسنان في عمان - رعاية طوارئ أسنان 24/7',
    keyword: 'Emergency dentist Amman',
    keywordAr: 'طوارئ أسنان عمان',
    keywords: ['Emergency dentist Amman', 'Dental emergency Amman', 'Urgent dental care Amman', '24/7 dentist Amman'],
    keywordsAr: ['طوارئ أسنان عمان', 'طوارئ أسنان عمان', 'رعاية أسنان عاجلة عمان', 'طبيب أسنان 24/7 عمان'],
    description: '24/7 emergency dental care in Amman. Immediate treatment for dental emergencies, pain relief, and urgent dental problems.',
    descriptionAr: 'رعاية طوارئ أسنان 24/7 في عمان. علاج فوري لحالات طوارئ الأسنان، تخفيف الألم، ومشاكل الأسنان العاجلة.'
  },
  {
    slug: 'family-dentist-amman',
    slugAr: 'طبيب-أسنان-عائلات-عمان',
    title: 'Family Dentist in Amman - Comprehensive Family Dental Care',
    titleAr: 'طبيب أسنان عائلات في عمان - رعاية أسنان عائلية شاملة',
    keyword: 'Family dentist Amman',
    keywordAr: 'طبيب أسنان عائلات عمان',
    keywords: ['Family dentist Amman', 'Family dental care Amman', 'General dentist Amman', 'Dentist for families Amman'],
    keywordsAr: ['طبيب أسنان عائلات عمان', 'رعاية أسنان عائلية عمان', 'طبيب أسنان عام عمان', 'طبيب أسنان للعائلات عمان'],
    description: 'Comprehensive family dental care in Amman. One dentist for your entire family - from children to seniors with complete dental services.',
    descriptionAr: 'رعاية أسنان عائلية شاملة في عمان. طبيب أسنان واحد لعائلتك بأكملها - من الأطفال إلى كبار السن مع خدمات أسنان كاملة.'
  },
  {
    slug: 'dental-cleaning-amman',
    slugAr: 'تنظيف-الأسنان-عمان',
    title: 'Dental Cleaning in Amman - Professional Teeth Cleaning Services',
    titleAr: 'تنظيف الأسنان في عمان - خدمات تنظيف أسنان احترافية',
    keyword: 'Dental cleaning Amman',
    keywordAr: 'تنظيف الأسنان عمان',
    keywords: ['Dental cleaning Amman', 'Teeth cleaning Amman', 'Dental hygiene Amman', 'Deep cleaning Amman'],
    keywordsAr: ['تنظيف الأسنان عمان', 'تنظيف الأسنان عمان', 'نظافة الأسنان عمان', 'تنظيف عميق للأسنان عمان'],
    description: 'Professional dental cleaning in Amman. Regular cleanings using rotary devices and advanced techniques for optimal oral health.',
    descriptionAr: 'تنظيف أسنان احترافي في عمان. تنظيف دوري باستخدام أجهزة الدوران وتقنيات متقدمة لصحة فم مثالية.'
  },
  {
    slug: 'gum-disease-treatment-amman',
    slugAr: 'علاج-لثة-عمان',
    title: 'Gum Disease Treatment in Amman - Periodontal Care',
    titleAr: 'علاج أمراض اللثة في عمان - رعاية لثوية',
    keyword: 'Gum disease treatment Amman',
    keywordAr: 'علاج لثة عمان',
    keywords: ['Gum disease treatment Amman', 'Periodontal treatment Amman', 'Gum treatment Amman', 'Periodontist Amman'],
    keywordsAr: ['علاج أمراض اللثة عمان', 'علاج أمراض اللثة عمان', 'علاج لثة عمان', 'أمراض اللثة عمان'],
    description: 'Expert gum disease treatment in Amman. Prevent and treat periodontal disease with advanced periodontal care techniques.',
    descriptionAr: 'علاج متخصص لأمراض اللثة في عمان. منع وعلاج أمراض اللثة مع تقنيات رعاية لثوية متقدمة.'
  },
  {
    slug: 'periodontist-amman',
    slugAr: 'أمراض-اللثة-عمان',
    title: 'Periodontist in Amman - Gum Disease Specialist',
    titleAr: 'أخصائي أمراض اللثة في عمان - متخصص في أمراض اللثة',
    keyword: 'Periodontist Amman',
    keywordAr: 'أمراض اللثة عمان',
    keywords: ['Periodontist Amman', 'Gum specialist Amman', 'Periodontal disease Amman', 'Gum health Amman'],
    keywordsAr: ['أخصائي أمراض اللثة عمان', 'متخصص لثة عمان', 'أمراض اللثة عمان', 'صحة اللثة عمان'],
    description: 'Expert periodontist in Amman specializing in gum health. Advanced periodontal treatments for healthy gums and strong teeth foundation.',
    descriptionAr: 'أخصائي أمراض اللثة متخصص في عمان متخصص في صحة اللثة. علاجات لثوية متقدمة للثة صحية وأساس أسنان قوي.'
  },
  {
    slug: 'oral-surgeon-amman',
    slugAr: 'جراحة-الفم-والفكين-عمان',
    title: 'Oral Surgeon in Amman - Oral and Maxillofacial Surgery',
    titleAr: 'جراح الفم والفكين في عمان - جراحة الفم والوجه والفكين',
    keyword: 'Oral surgeon Amman',
    keywordAr: 'جراحة الفم والفكين عمان',
    keywords: ['Oral surgeon Amman', 'Oral surgery Amman', 'Maxillofacial surgery Amman', 'Dental surgery Amman'],
    keywordsAr: ['جراح الفم والفكين عمان', 'جراحة الفم عمان', 'جراحة الوجه والفكين عمان', 'جراحة الأسنان عمان'],
    description: 'Expert oral and maxillofacial surgery in Amman. Advanced surgical procedures for wisdom teeth, implants, and oral pathologies.',
    descriptionAr: 'جراحة فم وفكين متخصصة في عمان. إجراءات جراحية متقدمة لأسنان الحكمة، الزراعة، وأمراض الفم.'
  },
  {
    slug: 'wisdom-teeth-removal-amman',
    slugAr: 'إزالة-أسنان-الحكمة-عمان',
    title: 'Wisdom Teeth Removal in Amman - Safe Extraction',
    titleAr: 'إزالة أسنان الحكمة في عمان - خلع آمن',
    keyword: 'Wisdom teeth removal Amman',
    keywordAr: 'إزالة أسنان الحكمة عمان',
    keywords: ['Wisdom teeth removal Amman', 'Wisdom tooth extraction Amman', 'Remove wisdom teeth Amman', 'Dental surgery Amman'],
    keywordsAr: ['إزالة أسنان الحكمة عمان', 'خلع أسنان الحكمة عمان', 'إزالة ضرس العقل عمان', 'جراحة الأسنان عمان'],
    description: 'Safe wisdom teeth removal in Amman. Expert extraction with minimal discomfort and comprehensive aftercare instructions.',
    descriptionAr: 'إزالة آمنة لأسنان الحكمة في عمان. خلع متخصص مع ألم محدود وتوجيهات رعاية ما بعد الجراحة الشاملة.'
  },
  {
    slug: 'veneers-amman',
    slugAr: 'قشور-أسنان-عمان',
    title: 'Dental Veneers in Amman - Porcelain Veneers for Perfect Smile',
    titleAr: 'قشور الأسنان في عمان - قشور خزفية لابتسامة مثالية',
    keyword: 'Veneers Amman',
    keywordAr: 'قشور الأسنان عمان',
    keywords: ['Veneers Amman', 'Porcelain veneers Amman', 'Dental veneers Amman', 'Smile makeover Amman'],
    keywordsAr: ['قشور الأسنان عمان', 'قشور خزفية عمان', 'قشور أسنان عمان', 'تجميل الابتسامة عمان'],
    description: 'Beautiful porcelain veneers in Amman. Transform your smile with custom-made veneers that look natural and last for years.',
    descriptionAr: 'قشور خزفية جميلة في عمان. حوّل ابتسامتك مع قشور مخصصة تبدو طبيعية وتستمر لسنوات.'
  },
  {
    slug: 'smile-makeover-amman',
    slugAr: 'ابتسامة-هوليود-عمان',
    title: 'Smile Makeover in Amman - Hollywood Smile Design',
    titleAr: 'ابتسامة هوليود في عمان - تصميم ابتسامة هوليود',
    keyword: 'Smile makeover Amman',
    keywordAr: 'ابتسامة هوليود عمان',
    keywords: ['Smile makeover Amman', 'Hollywood smile Amman', 'Perfect smile Amman', 'Smile design Amman'],
    keywordsAr: ['ابتسامة هوليود عمان', 'ابتسامة هوليود عمان', 'ابتسامة مثالية عمان', 'تصميم الابتسامة عمان'],
    description: 'Complete smile makeover in Amman. Hollywood smile design combining whitening, veneers, and cosmetic dentistry for stunning results.',
    descriptionAr: 'تجميل ابتسامة كامل في عمان. تصميم ابتسامة هوليود يجمع بين التبييض، القشور، وطب الأسنان التجميلي لنتائج مذهلة.'
  },
  {
    slug: 'dental-bridge-amman',
    slugAr: 'جسر-الأسنان-عمان',
    title: 'Dental Bridge in Amman - Fixed Bridge Restoration',
    titleAr: 'جسر الأسنان في عمان - ترميم جسر ثابت',
    keyword: 'Dental bridge Amman',
    keywordAr: 'جسر الأسنان عمان',
    keywords: ['Dental bridge Amman', 'Tooth bridge Amman', 'Fixed bridge Amman', 'Bridge restoration Amman'],
    keywordsAr: ['جسر الأسنان عمان', 'جسر أسنان عمان', 'جسر ثابت عمان', 'ترميم جسر عمان'],
    description: 'Fixed dental bridges in Amman. Replace missing teeth with durable bridges that restore function and aesthetics naturally.',
    descriptionAr: 'جسور أسنان ثابتة في عمان. استبدل الأسنان المفقودة بجسور متينة تعيد الوظيفة والجمال بشكل طبيعي.'
  },
  {
    slug: 'dental-crown-amman',
    slugAr: 'طربوش-أسنان-عمان',
    title: 'Dental Crown in Amman - Porcelain and Zirconia Crowns',
    titleAr: 'طربوش الأسنان في عمان - تيجان خزفية وزركونية',
    keyword: 'Dental crown Amman',
    keywordAr: 'طربوش أسنان عمان',
    keywords: ['Dental crown Amman', 'Tooth crown Amman', 'Porcelain crown Amman', 'Dental cap Amman'],
    keywordsAr: ['طربوش أسنان عمان', 'تيجان الأسنان عمان', 'تيجان خزفية عمان', 'غطاء الأسنان عمان'],
    description: 'High-quality dental crowns in Amman. Porcelain and zirconia crowns that protect and strengthen damaged teeth beautifully.',
    descriptionAr: 'تيجان أسنان عالية الجودة في عمان. تيجان خزفية وزركونية تحمي وتقوي الأسنان التالفة بشكل جميل.'
  },
  {
    slug: 'dental-hygiene-amman',
    slugAr: 'نظافة-الأسنان-عمان',
    title: 'Dental Hygiene in Amman - Professional Cleanings',
    titleAr: 'نظافة الأسنان في عمان - تنظيف احترافي',
    keyword: 'Dental hygiene Amman',
    keywordAr: 'نظافة الأسنان عمان',
    keywords: ['Dental hygiene Amman', 'Oral hygiene Amman', 'Dental care Amman', 'Teeth cleaning Amman'],
    keywordsAr: ['نظافة الأسنان عمان', 'نظافة الفم عمان', 'رعاية الأسنان عمان', 'تنظيف الأسنان عمان'],
    description: 'Professional dental hygiene services in Amman. Regular cleanings and oral health education for optimal dental wellness.',
    descriptionAr: 'خدمات نظافة أسنان احترافية في عمان. تنظيف دوري وتثقيف صحة الفم للرفاهية الأسنان المثلى.'
  },
  {
    slug: 'childrens-dental-clinic-amman',
    slugAr: 'فحص-الأسنان-للأطفال-عمان',
    title: 'Children\'s Dental Clinic in Amman - Pediatric Dental Care',
    titleAr: 'عيادة أسنان الأطفال في عمان - رعاية أسنان الأطفال',
    keyword: 'Children\'s dental clinic Amman',
    keywordAr: 'فحص الأسنان للأطفال عمان',
    keywords: ['Children\'s dental clinic Amman', 'Pediatric dental clinic Amman', 'Kids dental care Amman', 'Child dentist Amman'],
    keywordsAr: ['عيادة أسنان الأطفال عمان', 'عيادة أسنان أطفال عمان', 'رعاية أسنان الأطفال عمان', 'طبيب أسنان أطفال عمان'],
    description: 'Dedicated children\'s dental clinic in Amman. Child-friendly environment with specialized pediatric dental care for healthy young smiles.',
    descriptionAr: 'عيادة أسنان أطفال مخصصة في عمان. بيئة مناسبة للأطفال مع رعاية أسنان أطفال متخصصة لابتسامات صغيرة صحية.'
  },
  {
    slug: 'laser-teeth-whitening-amman',
    slugAr: 'تبييض-الأسنان-بالليزر-عمان',
    title: 'Laser Teeth Whitening in Amman - Advanced Whitening Technology',
    titleAr: 'تبييض الأسنان بالليزر في عمان - تقنية تبييض متقدمة',
    keyword: 'Laser teeth whitening Amman',
    keywordAr: 'تبييض الأسنان بالليزر عمان',
    keywords: ['Laser teeth whitening Amman', 'Laser whitening Amman', 'Teeth whitening laser Amman', 'Professional whitening Amman'],
    keywordsAr: ['تبييض الأسنان بالليزر عمان', 'تبييض بالليزر عمان', 'تبييض الأسنان بالليزر عمان', 'تبييض احترافي عمان'],
    description: 'Advanced laser teeth whitening in Amman. Fast, effective whitening using cutting-edge laser technology for dramatically whiter teeth.',
    descriptionAr: 'تبييض أسنان بالليزر متقدم في عمان. تبييض سريع وفعال باستخدام تقنية ليزر حديثة لأسنان أكثر بياضاً بشكل كبير.'
  },
  {
    slug: 'dental-restoration-amman',
    slugAr: 'ترميم-الأسنان-عمان',
    title: 'Dental Restoration in Amman - Restore Your Perfect Smile',
    titleAr: 'ترميم الأسنان في عمان - استعد ابتسامتك المثالية',
    keyword: 'Dental restoration Amman',
    keywordAr: 'ترميم الأسنان عمان',
    keywords: ['Dental restoration Amman', 'Tooth restoration Amman', 'Dental repair Amman', 'Restorative dentistry Amman'],
    keywordsAr: ['ترميم الأسنان عمان', 'ترميم أسنان عمان', 'إصلاح الأسنان عمان', 'طب الأسنان الترميمي عمان'],
    description: 'Expert dental restoration in Amman. Comprehensive restorative dentistry to repair and restore damaged or missing teeth.',
    descriptionAr: 'ترميم أسنان متخصص في عمان. طب أسنان ترميمي شامل لإصلاح واستعادة الأسنان التالفة أو المفقودة.'
  },
  {
    slug: 'dental-checkup-amman',
    slugAr: 'فحص-الأسنان-عمان',
    title: 'Dental Check-up in Amman - Regular Dental Examinations',
    titleAr: 'فحص الأسنان في عمان - فحوصات أسنان دورية',
    keyword: 'Dental check-up Amman',
    keywordAr: 'فحص الأسنان عمان',
    keywords: ['Dental check-up Amman', 'Dental examination Amman', 'Routine dental visit Amman', 'Dental exam Amman'],
    keywordsAr: ['فحص الأسنان عمان', 'فحص أسنان عمان', 'زيارة أسنان دورية عمان', 'فحص أسنان عمان'],
    description: 'Regular dental check-ups in Amman. Comprehensive examinations to maintain oral health and prevent dental problems early.',
    descriptionAr: 'فحوصات أسنان دورية في عمان. فحوصات شاملة للحفاظ على صحة الفم ومنع مشاكل الأسنان مبكراً.'
  },
  {
    slug: 'dental-xray-amman',
    slugAr: 'أشعة-الأسنان-عمان',
    title: 'Dental X-ray in Amman - Digital Dental Imaging',
    titleAr: 'أشعة الأسنان في عمان - تصوير أسنان رقمي',
    keyword: 'Dental X-ray Amman',
    keywordAr: 'أشعة الأسنان عمان',
    keywords: ['Dental X-ray Amman', 'Dental imaging Amman', 'Dental radiography Amman', 'X-ray dentist Amman'],
    keywordsAr: ['أشعة الأسنان عمان', 'تصوير الأسنان عمان', 'أشعة الأسنان عمان', 'أشعة أسنان عمان'],
    description: 'Advanced digital dental X-rays in Amman. Low-radiation imaging for accurate diagnosis and treatment planning.',
    descriptionAr: 'أشعة أسنان رقمية متقدمة في عمان. تصوير بإشعاع منخفض للتشخيص الدقيق وتخطيط العلاج.'
  },
  {
    slug: 'panoramic-dental-imaging-amman',
    slugAr: 'أشعة-بانوراما-أسنان-عمان',
    title: 'Panoramic Dental Imaging in Amman - Full Mouth X-rays',
    titleAr: 'أشعة بانوراما الأسنان في عمان - أشعة الفم الكاملة',
    keyword: 'Panoramic dental imaging Amman',
    keywordAr: 'أشعة بانوراما أسنان عمان',
    keywords: ['Panoramic dental imaging Amman', 'Panoramic X-ray Amman', 'Full mouth X-ray Amman', 'Dental imaging Amman'],
    keywordsAr: ['أشعة بانوراما أسنان عمان', 'أشعة بانوراما عمان', 'أشعة الفم الكاملة عمان', 'تصوير الأسنان عمان'],
    description: 'Panoramic dental imaging in Amman. Complete full-mouth X-rays for comprehensive diagnosis and treatment visualization.',
    descriptionAr: 'تصوير بانوراما الأسنان في عمان. أشعة فم كاملة شاملة للتشخيص والتصور العلاجي.'
  },
  {
    slug: 'dental-emergency-clinic-amman',
    slugAr: 'عيادة-طوارئ-أسنان-عمان',
    title: 'Dental Emergency Clinic in Amman - 24/7 Emergency Services',
    titleAr: 'عيادة طوارئ أسنان في عمان - خدمات طوارئ 24/7',
    keyword: 'Dental emergency clinic Amman',
    keywordAr: 'عيادة طوارئ أسنان عمان',
    keywords: ['Dental emergency clinic Amman', 'Emergency dental care Amman', 'Urgent dental clinic Amman', '24/7 dental clinic Amman'],
    keywordsAr: ['عيادة طوارئ أسنان عمان', 'رعاية طوارئ أسنان عمان', 'عيادة أسنان عاجلة عمان', 'عيادة أسنان 24/7 عمان'],
    description: '24/7 dental emergency clinic in Amman. Immediate care for dental emergencies, tooth pain, injuries, and urgent dental issues.',
    descriptionAr: 'عيادة طوارئ أسنان 24/7 في عمان. رعاية فورية لحالات طوارئ الأسنان، ألم الأسنان، الإصابات، ومشاكل الأسنان العاجلة.'
  },
  {
    slug: 'affordable-dentist-amman',
    slugAr: 'طبيب-أسنان-رخيص-عمان',
    title: 'Affordable Dentist in Amman - Quality Dental Care at Reasonable Prices',
    titleAr: 'طبيب أسنان بأسعار معقولة في عمان - رعاية أسنان عالية الجودة بأسعار معقولة',
    keyword: 'Affordable dentist Amman',
    keywordAr: 'طبيب أسنان بأسعار معقولة عمان',
    keywords: ['Affordable dentist Amman', 'Cheap dentist Amman', 'Budget dentist Amman', 'Cost-effective dental care Amman'],
    keywordsAr: ['طبيب أسنان بأسعار معقولة عمان', 'طبيب أسنان رخيص عمان', 'طبيب أسنان ميزانية عمان', 'رعاية أسنان فعالة التكلفة عمان'],
    description: 'Affordable quality dental care in Amman. High-standard dental services at competitive prices without compromising on quality.',
    descriptionAr: 'رعاية أسنان عالية الجودة بأسعار معقولة في عمان. خدمات أسنان عالية المعايير بأسعار تنافسية دون التنازل عن الجودة.'
  },
  {
    slug: 'dental-filling-amman',
    slugAr: 'حشو-الأسنان-عمان',
    title: 'Dental Filling in Amman - Tooth Restoration Services',
    titleAr: 'حشو الأسنان في عمان - خدمات ترميم الأسنان',
    keyword: 'Dental filling Amman',
    keywordAr: 'حشو الأسنان عمان',
    keywords: ['Dental filling Amman', 'Tooth filling Amman', 'Dental composite Amman', 'Tooth restoration Amman'],
    keywordsAr: ['حشو الأسنان عمان', 'حشو أسنان عمان', 'حشو تجميلي عمان', 'ترميم الأسنان عمان'],
    description: 'Professional dental fillings in Amman. High-quality composite fillings that match your natural tooth color and restore function.',
    descriptionAr: 'حشو أسنان احترافي في عمان. حشوات مركبة عالية الجودة تطابق لون أسنانك الطبيعية وتعيد الوظيفة.'
  },
  {
    slug: 'gum-surgery-amman',
    slugAr: 'خياطة-اللثة-عمان',
    title: 'Gum Surgery in Amman - Periodontal Surgery Procedures',
    titleAr: 'جراحة اللثة في عمان - إجراءات جراحة لثوية',
    keyword: 'Gum surgery Amman',
    keywordAr: 'خياطة اللثة عمان',
    keywords: ['Gum surgery Amman', 'Periodontal surgery Amman', 'Gum treatment Amman', 'Gum grafting Amman'],
    keywordsAr: ['جراحة اللثة عمان', 'جراحة لثوية عمان', 'علاج اللثة عمان', 'تطعيم اللثة عمان'],
    description: 'Expert gum surgery in Amman. Advanced periodontal procedures including gum grafting and periodontal surgery for healthy gums.',
    descriptionAr: 'جراحة لثة متخصصة في عمان. إجراءات لثوية متقدمة تشمل تطعيم اللثة وجراحة لثوية للثة صحية.'
  },
  {
    slug: 'dental-prosthesis-amman',
    slugAr: 'تركيب-الأسنان-عمان',
    title: 'Dental Prosthesis in Amman - Dental Replacement Solutions',
    titleAr: 'تركيب الأسنان في عمان - حلول استبدال الأسنان',
    keyword: 'Dental prosthesis Amman',
    keywordAr: 'تركيب الأسنان عمان',
    keywords: ['Dental prosthesis Amman', 'Dentures Amman', 'Dental replacement Amman', 'Prosthetic dentistry Amman'],
    keywordsAr: ['تركيب الأسنان عمان', 'أطقم الأسنان عمان', 'استبدال الأسنان عمان', 'طب الأسنان التعويضي عمان'],
    description: 'Expert dental prosthesis in Amman. Custom-made dentures and dental replacements that restore function and appearance naturally.',
    descriptionAr: 'أطقم أسنان متخصصة في عمان. أطقم أسنان مخصصة واستبدالات أسنان تعيد الوظيفة والمظهر بشكل طبيعي.'
  },
  {
    slug: 'deep-dental-cleaning-amman',
    slugAr: 'تنظيف-عميق-للأسنان-عمان',
    title: 'Deep Dental Cleaning in Amman - Scaling and Root Planing',
    titleAr: 'تنظيف عميق للأسنان في عمان - كشط وتخطيط الجذر',
    keyword: 'Deep cleaning Amman',
    keywordAr: 'تنظيف عميق للأسنان عمان',
    keywords: ['Deep cleaning Amman', 'Scaling and root planing Amman', 'Deep dental cleaning Amman', 'Periodontal cleaning Amman'],
    keywordsAr: ['تنظيف عميق للأسنان عمان', 'كشط وتخطيط الجذر عمان', 'تنظيف عميق للأسنان عمان', 'تنظيف لثوي عمان'],
    description: 'Deep dental cleaning in Amman. Scaling and root planing procedures to treat gum disease and restore oral health.',
    descriptionAr: 'تنظيف عميق للأسنان في عمان. إجراءات كشط وتخطيط الجذر لعلاج أمراض اللثة واستعادة صحة الفم.'
  },
  {
    slug: 'cosmetic-smile-amman',
    slugAr: 'ابتسامة-تجميلية-عمان',
    title: 'Cosmetic Smile in Amman - Aesthetic Dentistry Services',
    titleAr: 'ابتسامة تجميلية في عمان - خدمات طب الأسنان التجميلي',
    keyword: 'Cosmetic smile Amman',
    keywordAr: 'ابتسامة تجميلية عمان',
    keywords: ['Cosmetic smile Amman', 'Smile design Amman', 'Aesthetic dentistry Amman', 'Beautiful smile Amman'],
    keywordsAr: ['ابتسامة تجميلية عمان', 'تصميم الابتسامة عمان', 'طب الأسنان التجميلي عمان', 'ابتسامة جميلة عمان'],
    description: 'Beautiful cosmetic smile design in Amman. Aesthetic dentistry services to enhance your smile with veneers, whitening, and cosmetic procedures.',
    descriptionAr: 'تصميم ابتسامة تجميلية جميلة في عمان. خدمات طب الأسنان التجميلي لتحسين ابتسامتك مع القشور، التبييض، والإجراءات التجميلية.'
  },
  {
    slug: 'dental-technology-amman',
    slugAr: 'تقنيات-الأسنان-عمان',
    title: 'Advanced Dental Technology in Amman - Modern Dental Equipment',
    titleAr: 'تقنيات الأسنان المتقدمة في عمان - معدات أسنان حديثة',
    keyword: 'Dental technology Amman',
    keywordAr: 'تقنيات الأسنان عمان',
    keywords: ['Dental technology Amman', 'Modern dentistry Amman', 'Advanced dental equipment Amman', 'Digital dentistry Amman'],
    keywordsAr: ['تقنيات الأسنان عمان', 'طب الأسنان الحديث عمان', 'معدات أسنان متقدمة عمان', 'طب الأسنان الرقمي عمان'],
    description: 'State-of-the-art dental technology in Amman. Modern equipment including digital imaging, rotary devices, and advanced dental tools.',
    descriptionAr: 'تقنيات أسنان حديثة في عمان. معدات حديثة تشمل التصوير الرقمي، أجهزة الدوران، وأدوات أسنان متقدمة.'
  },
  {
    slug: 'dr-yousef-alsaket',
    slugAr: 'دكتور-يوسف-الساكت',
    title: 'Dr. Yousef AlSaket - Expert Dentist in Amman, Jordan',
    titleAr: 'الدكتور يوسف الساكت - طبيب أسنان متخصص في عمان، الأردن',
    keyword: 'Dr. Yousef AlSaket',
    keywordAr: 'دكتور يوسف الساكت',
    keywords: ['Dr. Yousef AlSaket', 'Yousef AlSaket dentist', 'AlSaket dental clinic', 'Dentist Yousef Amman'],
    keywordsAr: ['دكتور يوسف الساكت', 'يوسف الساكت طبيب أسنان', 'عيادة الساكت', 'طبيب أسنان يوسف عمان'],
    description: 'Meet Dr. Yousef AlSaket - Expert dentist in Amman with international qualifications. DDS from University of Jordan, MFD RCSI Ireland, and fellowship from University of Genoa.',
    descriptionAr: 'تعرف على الدكتور يوسف الساكت - طبيب أسنان متخصص في عمان بمؤهلات دولية. دكتور جراحة الأسنان من الجامعة الأردنية، MFD RCSI أيرلندا، وزمالة من جامعة جنوة.'
  }
];

// Generate slugs for both languages
export const getBlogSlug = (post, lang) => {
  return lang === 'ar' ? post.slugAr : post.slug;
};

// Find post by slug
export const getBlogPostBySlug = (slug, lang) => {
  return blogPosts.find(post => {
    const postSlug = lang === 'ar' ? post.slugAr : post.slug;
    return postSlug === slug;
  });
};

// Get all blog posts for sitemap
export const getAllBlogPosts = () => {
  const posts = [];
  blogPosts.forEach(post => {
    posts.push({ slug: post.slug, lang: 'en', priority: 0.7 });
    posts.push({ slug: post.slugAr, lang: 'ar', priority: 0.7 });
  });
  return posts;
};
